<template>
    <div>
        <div>
            <div class="main-wrapper">
                <div>
                    <!-- <layout-header2></layout-header2> -->
                    <layout-header></layout-header>
                    <breadcrumb57></breadcrumb57>
                    <!-- Page Content -->
                    <div class="content">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                    <sidebar></sidebar>
                                </div>

                                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                                    <loader></loader>
                                </div>

                                <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                                    <!-- Basic Information -->
                                    <i class="fa fa-arrow-left fa-lg ml-md-4" aria-hidden="true"
                                        style="background-color:black; color:white;padding:10px;border-radius:100%; cursor: pointer;"
                                        @click="goBack"></i>
                                    <div class="card mt-2 ml-md-4">
                                        <div class="card-body">
                                            <h3 class="mt-3">Investigation</h3>
                                            <div class="row mt-2">
                                                <div class="form-group">
                                                    <div class="col-md-12 col-sm-12 mt-2">
                                                        <label> {{ investigation_advice }}</label>
                                                        <input v-model="add_templates.template_name
                                                            " type="text" class="form-control" value="" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                                    if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                                                    </div>
                                                    <div class="col-md-12 col-sm-12 mt-2">
                                                        <label>Description</label>
                                                        <ckeditor :editor="editor" v-model="add_templates.description">
                                                        </ckeditor>
                                                    </div>

                                                    <div class="col-md-12 col-sm-12 mt-4">
                                                        <button data-dismiss="modal" aria-label="Close"
                                                            class="btn btn-primary submit-btn" @click="
                                                                // $bvModal.hide('Add_Diagnosis_modal');
                                                                add_new_templates();
                                                            ">
                                                            Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /Basic Information -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /Page Content -->
                    <layout-footer></layout-footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import { mapState } from "vuex";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
    data() {
        return {
            showspinner: false,
            add_templates: {
                category: "",
                template_name: "",
                description: "",
                doctor: this.user_id,
            },
            editor: ClassicEditor,
            investigation_advice: "",
        };
    },
    components: {
        ckeditor: CKEditor.component,
        // VueCsvImport,
    },
    computed: {
        ...mapState({
            user_id: (state) => state.user.user_id,
        }),

        template_validation() {
            return (
                this.add_templates.category &&
                this.add_templates.template_name &&
                this.add_templates.description
            );
        },
    },

    watch: {
        template_validation() {
            if (
                this.add_templates.category === "" ||
                this.add_templates.category === null ||
                this.add_templates.template_name === ""
            ) {
                this.disabled_template_button = true;
            } else {
                this.disabled_template_button = false;
            }
        },
        new_treatment_validation() {
            if (
                this.new_treatment.treatment_plan_name === "" ||
                this.new_treatment.status === "" ||
                this.new_treatment.status === null
            ) {
                this.disabled_template_button = true;
            } else {
                this.disabled_template_button = false;
            }
        },

    },
    methods: {

        async add_new_templates() {
            this.add_templates.category = this.investigation_advice;
            this.$swal({
                text: "Adding Template...",
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                },
            });
            await CommonApi.post_data(
                "sahaj.template.add_templates",
                this.add_templates
            ).then((res) => {
                this.showspinner = false;
                if (res && res.status_code === 200) {
                    this.$swal.fire({
                        icon: "success",
                        title: "Success",
                        text: res.message,
                        showConfirmButton: true,
                    }).then(() => {
                        this.$router.push(`/doctor/treatment-plan`);
                    });
                    this.$emit("close");
                } else {
                    this.$swal.fire({
                        icon: "warning",
                        title: "Warning",
                        text: res.message,
                        showConfirmButton: true,
                    });
                }
                this.add_templates.category = "";
                this.add_templates.template_name = "";
                this.add_templates.description = "";
            });
        },


        async get_template_category() {
            await CommonApi.get_data("sahaj.template.get_template_category").then(
                (res) => {
                    this.showspinner = false;
                    if (res && res.message) {
                        this.investigation_advice = res.message[5];
                    }
                }
            );
        },


        goBack() {
            // Go one page back
            this.$router.go(-1);
        },

    },
    mounted() {
        let user = localStorage.getItem("userInfo");
        if (!user) {
            this.$router.push({ name: 'login' })
        }
        this.get_template_category();
    },
};
</script>

<style scoped>
/* Default column widths */
.column-name {
    min-width: 400px;
}

.column-description {
    min-width: 520px;
}

.column-action {
    min-width: 90px;
}

/* Responsive column widths for smaller screens */
@media (max-width: 768px) {
    .column-name {
        min-width: 250px;
    }

    .column-description {
        min-width: 400px;
    }

    .column-action {
        min-width: 70px;
    }
}

/* Responsive column widths for even smaller screens */
@media (max-width: 480px) {
    .column-name {
        min-width: 150px;
    }

    .column-description {
        min-width: 250px;
    }

    .column-action {
        min-width: 60px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/addInvestigation.vue